/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import router from '../router'
// import ToastPlugin from 'vue-toast-notification'
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import i18n from '../locale/i18n'
export function registerPlugins (app) {
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)
  app.use(pinia)
  app.use(router)
  app.use(i18n)
  // app.use(ToastPlugin,{position:'top-right'})
  app.use(Toast, {
    position: POSITION.TOP_RIGHT,
    timeout: 2000,
    closeOnClick: true,
    pauseOnFocusLoss: false,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,  // 프로그레스바 보이게 설정
    closeButton: 'button',
    icon: true,
    rtl: false
  })
  app.use(vuetify)
}
